module.exports = __webpack_public_path__ + "img/certification-demo.0750aab5.png";